import Seo from "@/components/common/Seo";
import Hero from "@/components/home/Hero";
import TrustSection from "@/components/home/TrustSection";
import ProblemSolution from "@/components/home/ProblemSolution";
import AIHiringEngine from "@/components/home/AIHiringEngine";
import ServicesSection from "@/components/home/ServicesSection";
import IndustriesSection from "@/components/home/IndustriesSection";
import RecruitmentProcess from "@/components/home/RecruitmentProcess";
import SuccessStories from "@/components/home/SuccessStories";
import CountersSection from "@/components/home/CountersSection";
import WhyStudentsTrust from "@/components/home/WhyStudentsTrust";
import FAQSection from "@/components/home/FAQSection";
import FinalCTA from "@/components/home/FinalCTA";
import ContactForm from "@/components/home/ContactForm";

export default function Home() {
  return (
    <div data-testid="page-home">
      <Seo
        title="US IT Staffing & Placement for International Students"
        description="SKVY Harmony Placement helps international students, OPT, CPT and H-1B professionals land US tech jobs across software, data, AI, cloud and cybersecurity."
        path="/"
      />
      <Hero />
      <TrustSection />
      <ProblemSolution />
      <AIHiringEngine />
      <ServicesSection />
      <IndustriesSection />
      <RecruitmentProcess />
      <WhyStudentsTrust />
      <SuccessStories />
      <CountersSection />
      <FAQSection />
      <FinalCTA />
      <ContactForm />
    </div>
  );
}
